import { useEffect } from "react";
import { useNavigate } from "react-router";

export const exerciseStart = (
  studentId?: string,
  videoId?: string,
  hasReward = false
) => {
  if (videoId === undefined || studentId === undefined) {
    return;
  }

  const message = {
    type: "START_EXERCISE",
    payload: {
      screen: "ExercisePrepareScreen",
      params: {
        videoId: videoId,
        studentId: studentId,
        hasReward: hasReward,
      },
    },
  };

  // webview_flutter의 JavaScript 채널로 메시지 전송
  window.WebViewChannel?.postMessage(JSON.stringify(message));
};

export const reloadWebview = () => {
  const message = {
    type: "RELOAD",
  };

  // webview_flutter의 JavaScript 채널로 메시지 전송
  window.WebViewChannel?.postMessage(JSON.stringify(message));
};

export const deleteFcmToken = () => {
  const message = {
    type: "DELETE_FCM_TOKEN",
    payload: {},
  };

  // webview_flutter의 JavaScript 채널로 메시지 전송
  window.WebViewChannel?.postMessage(JSON.stringify(message));
};

export const saveFcmToken = (userId?: string, userType?: string) => {
  const message = {
    type: "SAVE_FCM_TOKEN",
    payload: { userId: userId, userType: userType },
  };

  // webview_flutter의 JavaScript 채널로 메시지 전송
  window.WebViewChannel?.postMessage(JSON.stringify(message));
};

export function useFlutterRouteHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    const listener = (event: MessageEvent) => {
      const { type, route } = event.data || {};
      if (type === "NAVIGATE" && typeof route === "string") {
        navigate(route);
      }
    };

    window.addEventListener("message", listener);
    return () => window.removeEventListener("message", listener);
  }, [navigate]);
}
